import { hipNew } from '../api';
import qs from 'querystring';
import ActionTypes from '../constants/ActionTypes';
import { camelizeRecursive } from '../utils/inflect';

export const fetchAdvertiseFormData = (query: any) => {
  const queryString = qs.stringify(query);
  const param = queryString ? `?${queryString}` : '';
  return async dispatch => {
    try {
      const { data: formData } = await hipNew.get(`/api/vars${param}`);
      return dispatch({
        type: ActionTypes.FETCH_ADVERTISE_FORM_DATA_SUCCESS,
        payload: camelizeRecursive(formData)
      });
    } catch (e) {
      return dispatch({
        type: ActionTypes.FETCH_ADVERTISE_FORM_DATA_ERROR
      });
    }
  };
};

export const fetchAdvertiseIncomingLeads = (categoryKey?: string) => {
  const query = categoryKey ? `/${categoryKey}` : '';
  return async dispatch => {
    try {
      const { data: incomingLeads } = await hipNew.get(`/api/incoming-leads${query}`);
      return dispatch({
        type: ActionTypes.FETCH_ADVERTISE_INCOMING_LEADS_SUCCESS,
        payload: incomingLeads
      });
    } catch (e) {
      return dispatch({
        type: ActionTypes.FETCH_ADVERTISE_INCOMING_LEADS_ERROR
      });
    }
  };
};

export const fetchAdvertiseRecommendations = (param?: string) => {
  const query = param ? `${param}` : '';
  return async dispatch => {
    try {
      const { data: recommendations } = await hipNew.get(`/api/recommendations${query}`);
      return dispatch({
        type: ActionTypes.FETCH_ADVERTISE_RECOMMENDATIONS_SUCCESS,
        payload: recommendations
      });
    } catch (e) {
      return dispatch({
        type: ActionTypes.FETCH_ADVERTISE_RECOMMENDATIONS_ERROR
      });
    }
  };
};

export const fetchAdvertiseCategoryList = () => {
  return async dispatch => {
    try {
      const { data: categoryList } = await hipNew.get(`/api/categories`);
      return dispatch({
        type: ActionTypes.FETCH_ADVERTISE_CATEGORY_LIST_SUCCESS,
        payload: categoryList
      });
    } catch (e) {
      return dispatch({
        type: ActionTypes.FETCH_ADVERTISE_CATEGORY_LIST_ERROR
      });
    }
  };
};

export const fetchAdvertiseWhereList = () => {
  return async dispatch => {
    try {
      const { data: whereList } = await hipNew.get(`/api/how-did-you-hear-about-us`);
      return dispatch({
        type: ActionTypes.FETCH_ADVERTISE_WHERE_LIST_SUCCESS,
        payload: whereList
      });
    } catch (e) {
      return dispatch({
        type: ActionTypes.FETCH_ADVERTISE_WHERE_LIST_ERROR
      });
    }
  };
};
